import React, { FunctionComponent } from 'react';
import MaydayLogo from '../../assets/icons/mayday.svg';
import translate from '../../language/translate';
import Overlay from './Overlay';

export const Loading: FunctionComponent = () => (
  <Overlay>
    <div
      className="fixed top-0 left-0 bottom-0 right-0 z-loading"
      data-testid="loading"
    >
      <div className="absolute top-0 left-0 bg-white bg-opacity-75 h-full w-full" />
      <div className="absolute top-0 left-0 h-full w-full flex flex-col justify-center justify-items-center items-center">
        <MaydayLogo className="w-logo-large animate-bounce" />
        <p className="text-xxl">{translate('Global.LOADING')}</p>
      </div>
    </div>
  </Overlay>
);

export const InlineLoading: FunctionComponent = () => (
  <div className="absolute top-0 left-0 bottom-0 right-0 z-loading min-h-header-bar-normal">
    <div className="absolute top-0 left-0 bg-white bg-opacity-75 h-full w-full" />
    <div className="absolute top-0 left-0 h-full w-full flex flex-col justify-center justify-items-center items-center">
      <MaydayLogo className="w-logo-large animate-bounce" />
      <p className="text-xxl">{translate('Global.LOADING')}</p>
    </div>
  </div>
);

export const SmallLoading: FunctionComponent = () => (
  <div className="fixed top-md right-md flex items-center px-xs py-sm z-loading bg-yellow-semi-transparent border-1 border-yellow">
    <MaydayLogo className="animate-bounce-spin mr-sm w-logo-tiny h-logo-tiny" />
    <p className="text-sm">{translate('Global.LOADING')}...</p>
  </div>
);
